module.exports = __webpack_public_path__ + "img/logo-bmci.69836f77.png";